/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMessage2Cancel = createReactComponent("message-2-cancel", "IconMessage2Cancel", [
  ["path", { d: "M8 9h8", key: "svg-0" }],
  ["path", { d: "M8 13h6", key: "svg-1" }],
  [
    "path",
    {
      d: "M12 21l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5",
      key: "svg-2"
    }
  ],
  ["path", { d: "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-3" }],
  ["path", { d: "M17 21l4 -4", key: "svg-4" }]
]);

export { IconMessage2Cancel as default };
//# sourceMappingURL=IconMessage2Cancel.js.map
